// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { CollateralAgreementChangeRequest } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/Collateral';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

const useCollateralAgreementChangeRequests: () => UseQueryResult<
  TemplateContract<CollateralAgreementChangeRequest>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data || '';
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryCollateralAgreementChangeRequests', ledgerApi, operator, offset],
    queryFn: async () => {
      return ledgerApi.queryCollateralAgreementChangeRequests(offset!);
    },
    refetchInterval: false,
  });
};

export default useCollateralAgreementChangeRequests;
